import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import UserEditable from '../../components/users/UserEditable';

class UserEditableContainer extends Component {
	componentWillMount() {
		const { setAttributeByObj, baseAttributes } = this.props;
		if(!!baseAttributes === true) {
			setAttributeByObj(baseAttributes);
		}
	}

	render() {
		const { user, cancelEditable, saveUser, resetPassword } = this.props;
		const action = {
			onChange: this.onChange,
			saveUser,
			cancelEditable,
			resetPassword
		}
		const initObj = Object.assign(user, action);
		return <UserEditable 
			{...initObj}
		/>
	}

	onChange = (value, attr) => {
		const { setAttribute } = this.props;
		setAttribute(value, attr);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setAttribute: (value, attr) => {
			const changeObj = {
				[attr]: value
			}
			dispatch(actions.user.setAttributeByObj(changeObj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.user.setAttributeByObj(obj));
		},
		saveUser: () => {
			dispatch(actions.user.saveUser())
		},
		resetPassword: () => {
			dispatch(actions.user.resetPassword())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEditableContainer);


// WEBPACK FOOTER //
// ./src/containers/users/UserEditableContainer.jsx